/* @generated */

// src/assets/ui-icon/line/upload-folder.tsx
import * as React from "react";
var UploadFolderLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m10.463 7-.377-.756A2.238 2.238 0 0 0 8.072 5H3.5v11.75A2.25 2.25 0 0 0 5.75 19H9.5v-1.5H5.75a.75.75 0 0 1-.75-.75V6.5h3.073a.745.745 0 0 1 .67.415L9.536 8.5H18.5v8.25a.75.75 0 0 1-.75.75H14V19h3.75A2.249 2.249 0 0 0 20 16.75V7h-9.537Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m14.61 15.21-2.86-2.75-2.86 2.75 1.04 1.08L11 15.263V19h1.5v-3.738l1.07 1.029 1.04-1.081Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  UploadFolderLine
};
